import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import initScrollTrigger from '../helpers/initScrollTrigger';
import сustomPageScroll from './custom-scroll';

import {IS_PHONE} from '../helpers/consts';
import horizontalMarquee from "./horizontalMarquee";

// const mapValue = function (val, in_min, in_max, out_min, out_max) {
//   return (val - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
// }

export default () => {
	if(IS_PHONE) return;

	initScrollTrigger();

	const bgSection = document.querySelector('.js-about-hero-bg');
	const fixedBlock = document.querySelector('.js-about-hero');
	const nextSection = document.querySelector('.js-parallax-section');

	if(!fixedBlock || !nextSection) return;
	let isScrolling = true;

	const trigger = ScrollTrigger.create({
		trigger: bgSection,
		start: 'top top',
		onEnter: () => {
			isScrolling = true;
		},
		onEnterBack: () => {
			isScrolling = true;
		},
		onLeave: () => {
			isScrolling = false;
		},
		end: () => {
			// const nextSectionH = nextSection.offsetHeight * 0.8 - fixedBlock.offsetHeight;
			const nextSectionH =  bgSection.offsetHeight* 0.8;
			return `+=${nextSectionH}`;
		},
		onUpdate: self => {
			const progress = self.progress;
			const opacity = 1 - progress;
			gsap.set(fixedBlock, { opacity: opacity });
		},
	});

	const initHehoAnimation = () => {
		сustomPageScroll.scroller.addListener(() => {
			if(!isScrolling) return;
			const scrollY = сustomPageScroll.scroller.offset.y;
			if(scrollY > 10) {
				fixedBlock.classList.add('is-scrolled');
			}
			else {
				fixedBlock.classList.remove('is-scrolled');
			}

			gsap.set(fixedBlock, { y: scrollY });
		});
	};

	initHehoAnimation();


	// About js Marquee
	const sections = document.querySelectorAll('.js-about-marquees-section');
	sections.forEach((section, index) => {
		const boxes = section.querySelectorAll('.horizontal__marquee__part');
		if (boxes.length) {
			const loop = horizontalMarquee(boxes, {
				paused: false,
				repeat: -1,
				reversed: false,
				speed: 0.5,
			});
		} else {
			console.warn(`No boxes found in section ${index}`);
		}
	});

};
